<template>
  <div class="">

    <div class="row m-0">
      <div class="hubLogo">
        <img height="400" src="img/brand/bannerMID.png">
      </div>
      <div class="col-4">

      </div>
      <div class="col-2">

      </div>
      <div class="col-5 pr-0 align-self-center">

        <div class="row justify-content-center m-0 mt-6">
          <div class="col-md-8 offset-md-2 pr-0">
            <router-link to="/commercial">
                <div  height="70" class="btn_commercial"></div>
              <!-- <img class="btn_selected" height="70"> -->
               <!-- src="img/icons/CREButton/commercial_default.png" -->
              <!-- <base-button
                size="sm"
                class="btn-customorange"
                type="light">
                <img src="img/icons/ButtonsIconsArcadisHub/btn_commercial.png">
              </base-button> -->
            </router-link>
            <!-- <label class="font-weight-bold text-dark">&nbsp;COMMERCIAL</label> -->
            <!-- <br><br> -->
            <router-link to="/management">
              <!-- <img height="70" src="img/icons/CREButton/management_default.png"> -->
              <div  height="70" class="btn_mngmt"></div>
              <!-- <base-button
                size="sm"
                class="btn-customorange">
                <img src="img/icons/ButtonsIconsArcadisHub/btn_management.png">
              </base-button> -->
            </router-link>
            <!-- <label class="font-weight-bold text-dark">&nbsp;MANAGEMENT</label> -->
            <!-- <br><br> -->
            <router-link to="/collaboration">
              <!-- <img height="70" src="img/icons/CREButton/collab_default.png"> -->
              <div  height="70" class="btn_collab"></div>
              <!-- <base-button
                size="sm"
                class="btn-customorange">
                <img src="img/icons/ButtonsIconsArcadisHub/btn_collab.png">
              </base-button> -->
            </router-link>
            <!-- <label class="font-weight-bold text-dark">&nbsp;COLLABORATION</label> -->
            <!-- <br><br> -->
            <router-link to="/design">
              <!-- <img height="70" src="img/icons/CREButton/design_default.png"> -->
              <div  height="70" class="btn_design"></div>
              <!-- <base-button
                size="sm"
                class="btn-customorange">
                <img src="img/icons/ButtonsIconsArcadisHub/btn_design.png">
              </base-button> -->
            </router-link>
            <!-- <label class="font-weight-bold text-dark">&nbsp;DESIGN</label> -->
            <!-- <br><br> -->
            <router-link to="/reporting">
              <!-- <img height="70" src="img/icons/CREButton/report_default.png"> -->
              <div  height="70" class="btn_report"></div>
              <!-- <base-button
                size="sm"
                class="btn-customorange">
                <img src="img/icons/ButtonsIconsArcadisHub/btn_reporting.png">
              </base-button> -->
            </router-link>
            <!-- <label class="font-weight-bold text-dark">&nbsp;REPORTING</label> -->
            <!-- <br><br> -->
            <router-link to="/virtualreality">
              <!-- <img height="70" src="img/icons/CREButton/vr_default.png"> -->
              <div  height="70" class="btn_vr"></div>
              <!-- <base-button
                size="sm"
                class="btn-customorange">
                <img src="img/icons/ButtonsIconsArcadisHub/btn_innovation.png">
              </base-button> -->
            </router-link>
            <!-- <label class="font-weight-bold text-dark">&nbsp;VIRTUAL REALITY</label> -->
            <!-- <router-link to="/innovation">
              <base-button
                size="sm"
                class="btn-customorange">
                <img src="img/icons/ButtonsIconsArcadisHub/btn_innovation.png">
              </base-button>
            </router-link>
            <label class="font-weight-bold text-dark">&nbsp;INNOVATION</label> -->
          </div>
        </div>
      </div>
    </div>

    <div class="bottomLogo">
      <a href="https://www.arcadis.com/en/australia/" target="_blank">
        <img height="80" style="padding: 10px;" src="img/brand/arcadisFullLogo.png">
      </a>
      <!-- <a href="https://www.ghd.com/" target="_blank">
        <img height="80" style="padding: 10px;" src="img/brand/ghdLogo.png">
      </a> -->
    </div>
  </div>
</template>

<script>
// import VueFrame from 'vue-frame'
export default {
  name: 'LandingPageNew',
  components: {
    // VueFrame
  },
  data() {
    return {
      links: {
        collab: ""
      },
      accessToken: ""
    }
  },
}
</script>

<style scoped>
.hubLogo {
  position: absolute;
  left: 130px;
  bottom: 350px;
  /* bottom: 0; */
}
.bottomLogo {
  padding-left:16px;
  position: absolute;
  bottom: 0;
}
.div-colab {
  z-index: 10;
  position: absolute;
  top: 350px;
  left: 505px;
}
.div-innovation {
  position: absolute;
  z-index: 1;
  top: 528px;
  left: 562px;
}
.div-report {
  z-index: 10;
  position: absolute;
  top: 528px;
  left: 1033px;
}
.div-design {
  z-index: 10;
  position: absolute;
  top: 50px;
  left: 1300px;
}
.div-management {
  z-index: 10;
  position: absolute;
  top: 201px;
  left: 1027px;
}
.div-commercial {
  position: absolute;
  z-index: 1;
  top: 372px;
  left: 1238px;
}
.my-auto {
  margin-top: auto;
margin-bottom: auto;
}

/* CENTERED BG */
/* .div-colab {
  z-index: 10;
  position: absolute;
  top: 350px;
  left: 636px;
}
.div-innovation {
  top: 528px;
  position: absolute;
  z-index: 1;
  left: 694px;
}
.div-report {
  z-index: 10;
  position: absolute;
  top: 528px;
  left: 1163px;
}
.div-design {
  z-index: 10;
  position: absolute;
  top: 50px;
  left: 1430px;
}
.div-management {
  z-index: 10;
  position: absolute;
  top: 201px;
  left: 1157px;
}
.div-commercial {
  position: absolute;
  z-index: 1;
  top: 372px;
  left: 1368px;
} */


</style>
